module.exports = __webpack_public_path__ + "2ae11d1b5a12905eb74847534d2a22fd.png";